import React, { Component } from "react";
import * as Utils from "../../../../models/utils";
import "./index.css";

class Row3 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { pdfInfo } = this.props;
    return (
      <div className="pdf-invoice-grid-row3">
        <div className="pdf-invoice-grid-row3-side-header">
          <div className="pdf-invoice-grid-row3-side-header-text">
            {"مشخصات کالا"}
          </div>
        </div>
        <div className="pdf-invoice-grid-row3-content">
          <div className="pdf-invoice-grid-row3-content-wrapper">
            <Header />
            <div className="pdf-invoice-grid-row3-content-plan-wrapper">
              <PlanRow pdfInfo={pdfInfo} />
            </div>
            <Sum pdfInfo={pdfInfo} />
          </div>
        </div>
      </div>
    );
  }
}

const Header = () => {
  return (
    <div className="pdf-invoice-grid-row3-content-header">
      <div className="pdf-invoice-grid-row3-content-cl0">ردیف</div>
      <div className="pdf-invoice-grid-row3-content-cl1">شرح کالا یا خدمات</div>
      <div className="pdf-invoice-grid-row3-content-cl2">مبلغ کل (ریال)</div>
      <div className="pdf-invoice-grid-row3-content-cl3">مبلغ تخفیف</div>
      <div className="pdf-invoice-grid-row3-content-cl4">
        مبلغ کل پس از تخفیف (ریال)
      </div>
      <div className="pdf-invoice-grid-row3-content-cl5">
        جمع مالیات و عوارض(ریال)
      </div>
      <div className="pdf-invoice-grid-row3-content-cl6">
        جمع مبلغ کل بهعلاوه جمع مالیات و عوارض (ریال)
      </div>
    </div>
  );
};

const PlanRow = (props) => {

  const _height = "148px";
  const _price = props.pdfInfo
    ? Utils.toRial((Math.round(props.pdfInfo.plan.totalPrice)*100)/100)
    : "-";

  const _orginalPrice = (((props.pdfInfo?.plan.totalPrice * 100)/110)*10) / (1 - (props.pdfInfo?.plan.discount ? props.pdfInfo?.plan.discount : 0))
  const _totalPriceWithoutTax = Utils.separateBy((_orginalPrice).toFixed(0), 3, ',')
  const _discount = props.pdfInfo?.plan.discount
                                ? Math.round( _orginalPrice * props.pdfInfo.plan.discount) * 100 / 100
                                : 0;
  const _finalPrice = _discount ? Utils.separateBy((_orginalPrice - (props.pdfInfo?.plan.discount ? _discount : 0)).toFixed(0), 3, ',') : 0;
  const _taxes = Utils.separateBy(((_orginalPrice  - (props.pdfInfo?.plan.discount ? _discount : 0)) * 0.10).toFixed(0), 3, ','); 
  const _month = props.pdfInfo ? props.pdfInfo.plan.duration : "-";
  const _user = props.pdfInfo ? props.pdfInfo.plan.maxActiveMembers : "-";
  const planName = props.pdfInfo ? ((props.pdfInfo.plan.maxActiveMembers > 1 ?' اشتراک سازمانی: ':'') + (props.pdfInfo.plan.displayName || '' )) : '';
  const userAndMonth =  _month.toLocaleString("fa-IR") +' ماهه/ ' + 'حداکثر کاربر مجاز : ' + _user.toLocaleString("fa-IR") +' نفر '
  return (
    <div
      className="pdf-invoice-grid-row3-content-plan"
      style={{ height: _height }}
    >
      <div className="pdf-invoice-grid-row3-content-cl0">
        {props.pdfInfo ? "۱" : "-"}
      </div>
      <div className="pdf-invoice-grid-row3-content-cl1">
        <div style={{ width: "100%", textAlign: "right" }}>
          <h2> بورس ویو</h2>
          <div style={{ fontSize: "16px" , direction:'ltr'}}> {planName}</div>
          <div style={{ fontSize: "16px" , marginTop: '10px'}}> {userAndMonth}</div>
        </div>
      </div>
      <div className="pdf-invoice-grid-row3-content-cl2">
        <h3>{Utils.zeroOutLastDigits(Utils.toPersianNumber(_totalPriceWithoutTax), 7)}</h3>
      </div>
      <div className="pdf-invoice-grid-row3-content-cl3">
        <h3>{Utils.zeroOutLastDigits(Utils.masckNumber(_discount), 7)}</h3>
      </div>
      <div className="pdf-invoice-grid-row3-content-cl4">
        <h3>{Utils.zeroOutLastDigits(Utils.masckNumber(_finalPrice), 7)}</h3>
      </div>
      <div className="pdf-invoice-grid-row3-content-cl5">
        <h3>{Utils.toPersianNumber(Utils.masckNumber(_taxes))}</h3>
      </div>
      <div className="pdf-invoice-grid-row3-content-cl6">
        <h3>{Utils.toPersianNumber(Utils.masckNumber(_price))}</h3>
      </div>
    </div>
  );
};

const Sum = (props) => {
  const _price = props.pdfInfo ? Utils.toRial(props.pdfInfo.price) : "-";
  return (
    <div className="pdf-invoice-grid-row3-content-sum">
      <div className="pdf-invoice-grid-row3-content-cl0"></div>
      <div className="pdf-invoice-grid-row3-content-cl1">
        <h3>جمع کل</h3>
      </div>
      <div className="pdf-invoice-grid-row3-content-cl2">-</div>
      <div className="pdf-invoice-grid-row3-content-cl3">-</div>
      <div className="pdf-invoice-grid-row3-content-cl4">-</div>
      <div className="pdf-invoice-grid-row3-content-cl5">-</div>
      <div className="pdf-invoice-grid-row3-content-cl6">
        <h3>{Utils.toPersianNumber(Utils.masckNumber(_price))}</h3>
      </div>
    </div>
  );
};

export default Row3;
